import {PAGE_URL, PERMISSION_KEY} from "../services/constant";
const nebulaPerformanceLogMenuRegistry = {
    personalize_nebulaPerformanceLog: {
        label: "Nebula Performance Log",
        link: PAGE_URL.NEBULA_PERFORMANCE_LOG_PAGE,
        key: PAGE_URL.NEBULA_PERFORMANCE_LOG_PAGE,
        resourceKey: PERMISSION_KEY
    }
}

export default nebulaPerformanceLogMenuRegistry;
